(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account($resource) {

        var service = $resource('api/account', {}, {
            'get': {
                method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            },
            'getImagem': {
                method: 'GET',
                url: 'api/imagem-usuario',
            },
            'getRedmine': {
                method: 'GET',
                url: 'api/account-redmine',
            },
            'getImagemAjustada': {
                method: 'GET',
                url: 'api/imagem-ajustada-usuario',
            },
            'getImagemAjustadaByLogin': {
                method: 'GET',
                url: 'api/imagem-ajustada-usuario/:login',
            },
            'saveImagem': {
                method: 'POST',
                url: 'api/imagem-usuario',
            },
            'saveRedmine': {
                method: 'POST',
                url: 'api/account-redmine',
            },
            'saveGit': {
                method: 'POST',
                url: 'api/account-git',
            }
        });

        return service;
    }
})();
